export enum ocrDocumentProposal {
    EducationReport,
    TrialPeriodReport,
    Unknown,
    None
}